import { ParticipanteAnotacao } from './../models/participante-anotacao.model';

import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ServiceBase } from '@app/services/base.service';
import { HttpClient } from '@angular/common/http';

import { DivisaoHonorarios } from '@app/pages/financeiro/financeiro-processo/financeiro-processo.model';
import { TutelaProvisoria } from '@app/models/util/tutela-provisoria.model';
import { RequisicaoFinanceira, RequisicaoFinanceiraHistorico } from '@app/models/requisicao-financeira.model';


@Injectable()
export class FinanceiroProcessoService extends ServiceBase {
  constructor(private http: HttpClient) {
    super();
  }

  adicionar(divisaoHonorarios: DivisaoHonorarios): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'financeiro/processo/divisaoDeHonorarios', divisaoHonorarios).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  adicionarPrestacaoDeContas(receberId: number){
    return this.http
      .put<any>(this.URL_API + 'financeiro/processo/adicionarPrestacaoDeContas', receberId).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  gravarTutela(tutela: TutelaProvisoria): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'financeiro/processo/tutelaProvisoria', tutela).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  obterProcesso(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `financeiro/processo/obterprocesso/${id}`);
  }

  obterCreditoParticipante(participanteId: number): Observable<any>{
    return this.http.get<any>(this.URL_API + `financeiro/participanteCredito/${participanteId}`);
  }

  procurarSaldoDevedor(participanteId: number, processoId: number){
    return this.http.get<any>(this.URL_API + `financeiro/processo/participanteSaldoDevedor/${participanteId}/${processoId}`);
  }

  obterAnotacoesProcesso(processoId: number){
    return this.http.get<any>(this.URL_API + `financeiro/processo/obterAnotacoesProcesso/${processoId}`);
  }

  salvarAnotacoesProcesso(participanteAnotacao: ParticipanteAnotacao){
    return this.http.post<any>(this.URL_API + 'financeiro/processo/salvarAnotacoesProcesso', participanteAnotacao).pipe(
      catchError((error: any) => observableThrowError(error))
    );
  }

  encerraTutela(idTutela: number, dataEncerrarTutela: string, decimoTerceiro: boolean, integral: boolean, gerarDevolucao: boolean, dataInicial: string): Observable<any>{
    return this.http
    .post<any>(this.URL_API + 'financeiro/processo/tutelaProvisoria/encerrarTutela', { TutelaId: idTutela, DataEncerramento: dataEncerrarTutela, DecimoTerceiro: decimoTerceiro, Integral: integral, GerarDevolucao: gerarDevolucao, DataInicial: dataInicial}).pipe(
      catchError((error: any) => observableThrowError(error))
    );
  }

  gravarRPV(rpv: RequisicaoFinanceira){
    return this.http.post<any>(this.URL_API + 'financeiro/processo/requisicao-financeira/rpv', rpv).pipe(
      catchError((error: any) => observableThrowError(error))
    );
  }

  gravarPrecatorio(precatorio: RequisicaoFinanceira){
    return this.http.post<any>(this.URL_API + 'financeiro/processo/requisicao-financeira/precatorio', precatorio).pipe(
      catchError((error: any) => observableThrowError(error))
    );
  }

  obterTodosRPV(processoId: number){
    return this.http.get<any>(this.URL_API + `financeiro/processo/requisicao-financeira/rpv/${processoId}`).pipe(
      catchError((error: any) => observableThrowError(error))
    );
  }

  obterTodosPrecatorio(processoId: number){
    return this.http.get<any>(this.URL_API + `financeiro/processo/requisicao-financeira/precatorio/${processoId}`).pipe(
      catchError((error: any) => observableThrowError(error))
    );
  }

  excluirRequisicaoFinanceira(id: number){
    return this.http.delete<any>(this.URL_API + `financeiro/processo/requisicao-financeira/${id}`).pipe(
      catchError((error: any) => observableThrowError(error))
    );
  }
  
  obterRequisicaoFinanceiraPorId(id: number){
    return this.http.get<any>(this.URL_API + `financeiro/processo/requisicao-financeira/${id}`).pipe(
      catchError((error: any) => observableThrowError(error))
    );
  }

  gravarHistoricoRequisicaoFinanceira(historico: RequisicaoFinanceiraHistorico){
    return this.http.post<any>(this.URL_API + 'financeiro/processo/requisicao-financeira/historico', historico).pipe(
      catchError((error: any) => observableThrowError(error))
    );
  }

  obterHistoricoRequisicaoFinanceira(idRequisicao: number){
    return this.http.get<any>(this.URL_API + `financeiro/processo/requisicao-financeira/historico/${idRequisicao}`).pipe(
      catchError((error: any) => observableThrowError(error))
    );
  }

}                                          
